var _rect, _path, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnMintOptionFenixlabs = function SvgIcnMintOptionFenixlabs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#FFF2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.65 12.604a3.513 3.513 0 0 0-.351-1.19 3.442 3.442 0 0 0-.798-1.19 10.232 10.232 0 0 0-1.77-1.47l-.254-.215a5.118 5.118 0 0 1-1.706-2.445c0-.149-.112-.1-.192 0a3.786 3.786 0 0 0-1.195 1.47c-.115.19-.2.396-.255.612a2.803 2.803 0 0 0-.224.793 3.319 3.319 0 0 0-.08.975c-.034.43.02.865.16 1.272.04.174.105.341.191.496h-.111a1.375 1.375 0 0 1-.575-.328 1.442 1.442 0 0 1-.366-.564 4.42 4.42 0 0 1-.175-.959c-.249.2-.464.44-.638.71a2.436 2.436 0 0 0-.526.96c-.132.227-.218.48-.255.743-.04.263-.04.53 0 .793-.002.301.035.601.111.892.196.928.638 1.78 1.276 2.462.177.198.375.376.59.529a1.836 1.836 0 0 0 1.647.185c.27-.1.514-.263.715-.475.2-.212.353-.47.444-.751a2.84 2.84 0 0 0 0-1.322 3.595 3.595 0 0 0-.16-.826l-.191-1.025c-.018-.472.13-.936.415-1.305.111 0 .095-.116 0-.198a1.06 1.06 0 0 1-.064-.446.596.596 0 0 1 0-.496c.07.172.182.323.324.44.142.115.31.191.489.22h.43a1.1 1.1 0 0 1 .563.28c.158.146.272.336.33.547 0 .198 0 .43.112.595.206.22.335.505.366.81 0 .165 0 0-.127 0a1.636 1.636 0 0 0-.893-.314.462.462 0 0 0-.407.14.5.5 0 0 0-.135.421c.028.287.104.566.223.827.09.314.197.623.32.925.046.269.162.52.334.727.103.162.248.29.418.371a.973.973 0 0 0 1.05-.136c.146-.122.256-.283.317-.466.136-.19.238-.402.303-.628.178-.373.286-.776.32-1.19.073-.415.073-.84 0-1.256Zm-5.166 2.016v-.71.71Z",
    fill: "url(#icn_mint_option_fenixlabs_svg__a)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#FF7A24"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icn_mint_option_fenixlabs_svg__a",
    x1: 14.254,
    y1: 6.541,
    x2: 8.259,
    y2: 16.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA32C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3618"
  })))));
};
export default SvgIcnMintOptionFenixlabs;